import { useEffect, useRef } from 'react';
import { callFunction } from '../lib/callables';
import type { ArenaEvent } from '../types/arena';

export function useHeartbeat(enabled: boolean, event: ArenaEvent | null) {
  const inFlight = useRef(false);
  useEffect(() => {
    if (!enabled || event?.status === 'finished') return;
    const beat = async () => {
      if (inFlight.current || !navigator.onLine) return;
      inFlight.current = true;
      try {
        await callFunction('heartbeat', {});
      } catch {
        // The next heartbeat retries; server timestamps remain authoritative.
      } finally {
        inFlight.current = false;
      }
    };
    void beat();
    const interval = window.setInterval(() => void beat(), 4000);
    const countdownTimer = event?.status === 'countdown' && event.startsAtMs
      ? window.setTimeout(() => void beat(), Math.max(0, event.startsAtMs - Date.now() + 25))
      : undefined;
    const online = () => void beat();
    window.addEventListener('online', online);
    return () => {
      window.clearInterval(interval);
      if (countdownTimer !== undefined) window.clearTimeout(countdownTimer);
      window.removeEventListener('online', online);
    };
  }, [enabled, event?.startsAtMs, event?.status]);
}
